import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { CLIENT_REDUCER_TOKEN, clientReducerProvider, rootReducerKey } from './client.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ClientEffects } from './client.effects';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(rootReducerKey, CLIENT_REDUCER_TOKEN),
    EffectsModule.forFeature([ClientEffects])
  ],
  providers: [
    clientReducerProvider
  ]
})
export class ClientStoreModule {
}
